// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"d3fc8cf4","192":"d3fc8cf4","336":"374d695e"}[chunkId] + ".chunk.css";
};